import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';

import { StyledGoalItemLabelCloseButton, StyledGoalItemLabelWrap } from './styled';

interface PropsType {
	label: string;
	number: number;
	onRemove: () => void;
}

function GoalItemFormCheckBox({ label, number, onRemove }: PropsType) {
	const handleClick = () => {
		onRemove();
	};

	return (
		<StyledGoalItemLabelWrap>
			<StyledGoalItemLabelCloseButton size="small" color="error" onClick={handleClick}>
				<CloseIcon />
			</StyledGoalItemLabelCloseButton>
			<Typography>{`${number}. ${label}`}</Typography>
		</StyledGoalItemLabelWrap>
	);
}

export default GoalItemFormCheckBox;
